import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import {
  IdentityA11yAnnouncer,
  IdentityButton,
  IdentityError as IdentityErrorView,
  IdentityFooterInline,
  IdentityHero,
  IdentityLayout,
  IdentitySuccess,
} from "@speedycore/identity-ui";
import { identityForgotPassword } from "../lib/identityApi";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [a11y, setA11y] = useState<string>("");

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await identityForgotPassword(email.trim());
      setDone(true);
      setA11y("Reset link on the way.");
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Request failed.";
      setError(msg);
      setA11y(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <IdentityA11yAnnouncer message={a11y} type={error ? "error" : "success"} />
      <IdentityLayout
        hero={
          <IdentityHero
            title="Reset your SpeedyCore password"
            subtitle="If you didn't request this, you can safely ignore this email."
          />
        }
        form={
          <>
            {done ? (
              <IdentitySuccess message="If an account exists for that email, a reset link is on the way. Check your inbox." />
            ) : (
              <form className="sc-identity-form" onSubmit={(e) => void onSubmit(e)} noValidate>
                <label>
                  Email
                  <input
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </label>
                {error ? <IdentityErrorView message={error} /> : null}
                <IdentityButton type="submit" label="Send reset link" loading={busy} />
              </form>
            )}
            <div className="sc-identity-links" style={{ marginTop: "1rem" }}>
              <Link to="/auth/login">Back to sign in</Link>
            </div>
            <IdentityFooterInline />
          </>
        }
      />
    </>
  );
}
